import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getReveiwList } from "../../api/common";
import Alert from "../../Components/AlertPopup";
import SubmitButton from "../../Components/Button";
import OrganizationList from "../../Components/OrgModal/OrganizationList";
import TableContainer from "../../Components/Table";
import { AUDIT_MODES, ERROR_MESSAGE } from "../../constants";
import ShowAttendees from "../../Containers/ShowAttendees";
import Info from "../../icons/infoIcon.svg?react";
import Review from "../../icons/reviewDetailIcon.svg?react";

import {
  calculateOffset,
  getAuditLevelLabel,
  getDateFormat,
  getUniqueAppNames,
} from "../../utils";
import PageContainer from "../PageContainer";
import styles from "./style.module.scss";
import AuditInformationModal from "../../Components/InfoModal/AuditInformationModal";

const AuditReview = () => {
  const [loading, setLoading] = useState(false);
  const [rowData, setRowData] = useState<[]>([]);
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [showModal, setShowModal] = useState(false);
  const [showQuestionModal, setShowQuestionModal] = useState(false);
  const [auditId, setAuditId] = useState("");
  const [showInfo, setShowInfo] = useState(false);
  const [element, setElement] = useState([]);

  const navigate = useNavigate();

  const columnData = [
    { label: "No", key: "no" },
    { label: "Audit ID", key: "auditCode" },
    {
      label: "Organization",
      key: "orgDetails",
      tdClassname: "text-start wrapTheme",
    },
    {
      label: "Application",
      key: "applicationList",
      tdClassname: "text-start wrapTheme",
    },
    { label: "Theme", key: "theme", tdClassname: "text-start wrapTheme" },
    { label: "Level", key: "auditLevel", tdClassname: "text-center" },
    {
      label: "Duration",
      key: "duration",
      tdClassname: "text-center",
    },
    { label: "Response Time", key: "responseTime", isMoreField: true },
    {
      label: "Reminder Alert",
      key: "escalationFrequency",
      tdClassname: "text-center",
      isMoreField: true,
    },
    { label: "Action", key: "action", disableSortBy: true },
    { label: "Info", key: "info", disableSortBy: true },
  ];

  const MoreFeildsValue = [
    {
      label: "Response Time",
      value: "responseTime",
      tdClassname: "text-start",
    },
    {
      label: "Reminder Alert",
      value: "escalationFrequency",
      tdClassname: "text-center",
    },
  ];

  const showQuestions = (id: string) => {
    setAuditId(id);
    setShowQuestionModal(true);
  };

  useEffect(() => {
    // eslint-disable-next-line
    fetchData(1);
  }, []);
  const handleErrorClose = () => setShowErrorToast(false);

  const fetchData = async (pageNumber: number) => {
    setLoading(true);
    const finalSet: any = [];
    getReveiwList(calculateOffset(pageNumber))
      .then((response) => {
        if (response) {
          let i = 1;
          response.forEach((element: any) => {
            finalSet.push({
              ...element,
              no: i,

              kickoffDate:
                getDateFormat(element.kickOffFromDate, "DD/MM/YYYY") +
                " - " +
                getDateFormat(element.kickOffFromDate, "hh:mm A") +
                " to " +
                getDateFormat(element.kickOffToDate, "hh:mm A"),
              auditMode: AUDIT_MODES[element.auditMode],
              createdDate: getDateFormat(element.createdOn, "DD/MM/YYYY"),
              auditLevel: `${getAuditLevelLabel(element.auditLevel)} (${element.auditLevel})`,
              applicationList: getUniqueAppNames(element.organizations),
              duration: `${element.startDate?.split("-")?.reverse()?.join("/")} - ${element.endDate?.split("-")?.reverse()?.join("/")}`,
              escalationFrequency: element.escalationFrequency ? `${element.escalationFrequency} Days` : "-",
              responseTime: `${element.responseTime} Days`,
              action: (
                <SubmitButton
                  type="primary"
                  // className={"review_btn_secondary"}
                  onClick={() =>
                    navigate(
                      "/in-progress/review-details/" + element.auditingId,
                      {
                        state: {
                          from: "/in-progress",
                          fromLabel: "Audit In Progress",
                        },
                      }
                    )
                  }
                >
                  <Review className="reviewbtnIcons" />
                  &nbsp;&nbsp;Review
                </SubmitButton>
              ),
              action2: (
                <SubmitButton
                  type="secondary"
                  onClick={() => showQuestions(element.auditingId)}
                >
                  Complete
                </SubmitButton>
              ),
              theme: element.themes
                .map((data: any) => data?.themeName)
                .join(", "),
              orgDetails: (
                <OrganizationList
                  title="Organization Under Audit ID:"
                  auditCode={element.auditCode}
                  organizations={element.organizations}
                />
              ),
              info: (
                <span>
                  <Info
                    className={styles.iconStyleActions}
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowInfo(true);
                      setElement(element);
                    }}
                  />
                </span>
              ),
            });
            i++;
          });
        }
        setRowData(finalSet);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        setShowErrorToast(true);
      });
  };
  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  const handlePageSizeChange = (newLimit: number) => {
    setPageSize(newLimit);
    setCurrentPage(1); // Reset to first page on limit change
  };
  const lastPostIndex = currentPage * pageSize;
  const firstPostIndex = lastPostIndex - pageSize;
  const currentReviews = rowData.slice(firstPostIndex, lastPostIndex);
  return (
    <PageContainer>
      <div className={styles.title}>Audit In Progress</div>

      <div className={styles.actionItem}>
        <div className={styles.tabs}></div>
      </div>

      <div>
        <TableContainer
          columnData={columnData}
          rowData={currentReviews}
          totalResult={rowData.length}
          enableMoreFeilds={true}
          MoreFeildsValue={MoreFeildsValue}
          title={"List of In Progress Audits"}
          enableActionButton={false}
          enableFilter={true}
          itemsPerPage={pageSize}
          currentPage={currentPage}
          setCurrentPage={(pageNumber) => {
            setCurrentPage(pageNumber);
            fetchData(pageNumber);
          }}
          onPageNoChange={handlePageChange}
          onPageLimitChange={handlePageSizeChange}
          showLoading={loading}
          noRecordMessage={"There are no audits in the In Progress stage."}
        />
      </div>
      <Alert
        type="error"
        show={showErrorToast}
        onClose={handleErrorClose}
        message={ERROR_MESSAGE.API_ERROR_MESSAGE}
      />

      <ShowAttendees
        showModal={showModal}
        auditId={auditId}
        onClose={() => {
          setShowModal(false);
        }}
      />
      <AuditInformationModal
        element={element}
        show={showInfo}
        onHide={() => setShowInfo(false)}
      />
    </PageContainer>
  );
};

export default AuditReview;
